const config = {
  subscriptionsEndpoint: "/api/commerce/subscriptionsoptions/v1/subscriptions",
  deliveryOptionsEndpoint:
    "/api/commerce/deliveryoptions/v2/deliverycountryoptions",
};

export default config;
